"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const caseTypes = [{
  title: "Supplier Portal",
  description: "Access global procurement opportunities, manage trade documentation, and connect with verified international buyers.",
  category: "Procurement",
  tagClass: "bg-accent/10 text-accent border-accent/20",
  link: "/SupplierPortalPage"
}, {
  title: "Buyer Portal",
  description: "Source premium commodities with rigorous quality assurance, real-time logistics tracking, and transparent pricing.",
  category: "Sourcing",
  tagClass: "bg-secondary/20 text-secondary-hover border-secondary/30",
  link: "/BuyerPortalPage"
}, {
  title: "Trade Networking",
  description: "Strategic B2B matchmaking connecting reliable producers with high-volume distributors across global markets.",
  category: "Networking",
  tagClass: "bg-primary-dark text-muted-foreground border-primary",
  link: "/ProductsServicesPage"
}, {
  title: "Logistics Tracking",
  description: "End-to-end visibility of your commodity shipments from origin port to final destination warehouse.",
  category: "Operations",
  tagClass: "bg-secondary/20 text-secondary-hover border-secondary/30",
  link: "/OperationsPage"
}, {
  title: "Quality Compliance",
  description: "Digital access to inspection reports, ISO certifications, and laboratory testing results for every batch.",
  category: "Procurement",
  tagClass: "bg-accent/10 text-accent border-accent/20",
  link: "/ProductsServicesPage"
}, {
  title: "Market Insights",
  description: "Real-time data on commodity pricing trends, supply chain shifts, and international trade regulations.",
  category: "Networking",
  tagClass: "bg-primary-dark text-muted-foreground border-primary",
  link: "/BlogMarketInsightsPage"
}, {
  title: "Document Vault",
  description: "Secure management of Bills of Lading, Certificates of Origin, and commercial invoices for seamless customs.",
  category: "Procurement",
  tagClass: "bg-accent/10 text-accent border-accent/20",
  link: "/OperationsPage"
}, {
  title: "Custom Solutions",
  description: "Tailored sourcing strategies and private label support for large-scale retail and manufacturing partners.",
  category: "Sourcing",
  tagClass: "bg-secondary/20 text-secondary-hover border-secondary/30",
  link: "/ProductsServicesPage"
}];
export default function CaseTypesGrid() {
  return <section data-section-id="246096" id="portalbanner" className="relative w-full py-24 lg:py-32 bg-primary-dark overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/global_trade_logistics_bg.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/global_trade_logistics_bg.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542426/img/global_trade_logistics_bg.png-wvc-sizes" alt="Global trade and logistics background" className="w-full h-full object-cover object-center" loading="lazy" />
        <div className="absolute inset-0 bg-primary-dark/85 mix-blend-multiply"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4 md:px-6">
        {}
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <h2 className="text-4xl md:text-5xl font-default text-accent mb-6 tracking-tight">
            Global Trade Portals
          </h2>
          <p className="text-light-background/80 text-lg md:text-xl font-sans leading-relaxed">
            Streamlined digital ecosystems for suppliers and buyers to manage international procurement and logistics with total transparency.
          </p>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {caseTypes.map((item, i) => <div key={i} data-index={i} className="h-full">
              <Card className="h-full flex flex-col rounded-md bg-primary/95 backdrop-blur-sm border-thin border-accent/30 hover:border-accent transition-all duration-300 group shadow-soft hover:shadow-medium">
                <CardHeader className="pb-4">
                  <div className="mb-4">
                    <Badge variant="outline" className={`rounded-sm uppercase tracking-wider text-[10px] font-bold px-2.5 py-1 ${item.tagClass}`}>
                      {item.category}
                    </Badge>
                  </div>
                  <CardTitle className="text-accent font-default text-xl leading-tight group-hover:text-accent-light transition-colors">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-6">
                  <p className="text-light-background/70 text-sm font-sans leading-relaxed">
                    {item.description}
                  </p>
                </CardContent>
                <CardFooter className="pt-0 mt-auto">
                  <Link to={item.link} className="inline-flex items-center gap-2 text-accent text-xs font-display font-bold uppercase tracking-widest hover:text-light-background transition-colors group/link">
                    Access Portal 
                    <ArrowRight className="w-4 h-4 transform group-hover/link:translate-x-1 transition-transform" />
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}